import { compose } from "redux";
import { Set } from "immutable";
import Dropzone from "react-dropzone";
import React, { PureComponent } from "react";

import { invokeIfFunction } from "utils/app.util";

class FileUploadField extends PureComponent {
  constructor(props) {
    super(props);

    this.dropzoneRef = React.createRef();
  }

  openFileDialog = () => {
    if (this.dropzoneRef.current) this.dropzoneRef.current.open();
  };

  onDrop = acceptedFiles => {
    const { input, multiple } = this.props;
    const { value, onChange } = input;

    onChange(multiple ? value.concat(acceptedFiles) : Set(acceptedFiles));
  };

  removeFile = file => {
    const { input } = this.props;
    const { value, onChange } = input;

    onChange(value.delete(file));
  };

  render() {
    const { children, multiple, DropzoneProps } = this.props;

    return (
      <Dropzone
        noClick
        multiple={multiple}
        onDrop={this.onDrop}
        ref={this.dropzoneRef}
        {...DropzoneProps}
      >
        {({ getInputProps, ...dropzoneProps }) => (
          <>
            <input type="hidden" {...getInputProps()} />
            {invokeIfFunction(children, {
              ...dropzoneProps,
              openFileDialog: this.openFileDialog,
            })}
          </>
        )}
      </Dropzone>
    );
  }
}

export default compose()(FileUploadField);
